<template>
    <LoginComponent />
</template>

<script>
import LoginComponent from '@/components/Login.vue';

export default {
  name: 'LoginWorld',
  components: {
    LoginComponent
  },
  methods: {
  }
}
</script>

<style></style>
